import React from "react";
import Header from "../components/Header";

export default function Payframe({url}) {

    return (
        <iframe src={url} className={"payframe"} title="payframe"></iframe>
    )
}
